import { ActionTypes as actions, PracticeActions, ConsultationsActions, UserActions, ScheduleActions } from '../actions';
import { History as history, Routes as routes } from '../navigation';

const switchLoggedInRole = (newRole) => {
  return dispatch => {
    dispatch(updatedContextPracticeAndRole('', newRole));
  }
}

const switchLoggedInPracticeAndRole = (newPractice, newRole) => {
  return dispatch => {
    dispatch(updatedContextPracticeAndRole(newPractice, newRole));
  }
}

const updatedContextPracticeAndRole = (practice, role) => {
  return (dispatch, getState) => {

    let prevPractice  = getState().context.selectedPractice;
    let samePractice  = prevPractice && prevPractice === practice ? true : false;
    let all_practices = getState().user.practices;
    let current_practice = all_practices && all_practices[practice] ? all_practices[practice] : {};

    if (practice && practice !== '') {
      dispatch({ type: actions.CONTEXT_UPDATE_PRACTICE, payload: practice });
      dispatch(PracticeActions.getSelectedPractice(practice));
    }

    if (role && role !== '') {
      dispatch({ type: actions.CONTEXT_UPDATE_ROLE, payload: role });
    }

    if (!samePractice) {
      dispatch(cleanPracticeSpecificData());
      dispatch(performNewPracticeTasks());
    }

    let is_instant = current_practice && current_practice.subscription && (current_practice.subscription.subscription_type === 'INSTANT' || current_practice.subscription.subscription_type === 'INSTANT_PAID') ? true : false;

    if (is_instant) {
      history.push(routes.INSTANT_HOME);
    } else {
      history.push(routes.HOME);
    }

  }
}

const performNewPracticeTasks = () => {
  return (dispatch, getState) => {

    const user_id = getState().user.auth.user_id;
    const practice = getState().context.selectedPractice;
    const role = getState().context.selectedRole;
    const token = getState().user.auth.token;

    if (practice && role && token && user_id) {

      dispatch(PracticeActions.populateSelectedPracticeInfo());
      dispatch(PracticeActions.getPracticeLocations(token, practice));

      if (role === 'admin') {

      }
      if (role === 'practice_owner' || role === 'practice_manager' || role === 'admin') {
        dispatch(PracticeActions.getPracticeNotificationPreferences(token, practice));
        dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'ACTIVE', practice));
        dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'UNASSIGNED', practice));
        dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'RESOLVED', practice));
        dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'PROCESSING', practice));
        dispatch(PracticeActions.getPracticeJoinRequests(token, practice));
        dispatch(PracticeActions.getPracticeStaff(token, practice));
        dispatch(PracticeActions.getPracticeBank(token, practice));
        dispatch(PracticeActions.getPracticeClients(token, practice));
        dispatch(PracticeActions.getPracticeAlerts(token, practice));
        dispatch(PracticeActions.getPracticeStripeAccount(token, practice));
        dispatch(ScheduleActions.getPracticeAppointments(token, practice));
      }
      if (role === 'vet') {
        dispatch(ConsultationsActions.getUserPreviewConsultations(token, 'ACTIVE'));
        dispatch(ConsultationsActions.getUserPreviewConsultations(token, 'RESOLVED'));
        dispatch(PracticeActions.getPracticeAlerts(token, practice));
        dispatch(ScheduleActions.getUserAppointments(token, user_id));
      }
      if (role === 'tech') {
        dispatch(ConsultationsActions.getUserPreviewConsultations(token, 'ACTIVE'));
        dispatch(ConsultationsActions.getUserPreviewConsultations(token, 'RESOLVED'));
        dispatch(ScheduleActions.getUserAppointments(token, user_id));
      }
      if (role === 'behaviorist') {
        dispatch(ConsultationsActions.getUserPreviewConsultations(token, 'ACTIVE'));
        dispatch(ConsultationsActions.getUserPreviewConsultations(token, 'RESOLVED'));
        dispatch(ScheduleActions.getUserAppointments(token, user_id));
      }

      if (role === 'front_desk') {
        dispatch(PracticeActions.getFrontDeskUserTasks(token));
        dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'ACTIVE', practice));
        dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'UNASSIGNED', practice));
        dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'RESOLVED', practice));
        dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'PROCESSING', practice));
        dispatch(ScheduleActions.getPracticeAppointments(token, practice));
      }
    }
  }
}

const fetchDataForScreenAndRole = (screenName) => {
  return (dispatch, getState) => {

    const user_id = getState().user.auth.user_id;
    const practice = getState().context.selectedPractice;
    const role = getState().context.selectedRole;
    const token = getState().user.auth.token;

    if (practice && role && token && screenName && user_id) {
      switch (screenName) {
        case 'home':
          dispatch(fetchDataForHomeScreen(practice, role, token, user_id));
          break;
        case 'consultations':
          dispatch(fetchDataForConsultationsScreen(practice, role, token, user_id));
          break;
        case 'practice':
          dispatch(fetchDataForPracticeScreen(practice, role, token, user_id));
          break;
        case 'staff':
          dispatch(fetchDataForStaffScreen(practice, role, token, user_id));
          break;
        case 'clients':
          dispatch(fetchDataForClientsScreen(practice, role, token, user_id))
          break;
        case 'myaccount':
          dispatch(fetchDataForMyAccountScreen(practice, role, token, user_id));
          break;
        case 'settings':
          dispatch(fetchDataForSettingsScreen(practice, role, token, user_id));
          break;
        default:

      }
    }
  }
}

const fetchDataForHomeScreen = (practice, role, token, user_id) => {
  return dispatch => {

    if (role === 'practice_owner' || role === 'practice_manager' || role === 'admin') {
      dispatch(PracticeActions.getPracticeJoinRequests(token, practice));
      dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'ACTIVE', practice));
      dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'UNASSIGNED', practice));
      dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'RESOLVED', practice));
      dispatch(ConsultationsActions.getPracticePreviewConsultations(token, 'PROCESSING', practice));
      dispatch(PracticeActions.getPracticeLocations(token, practice));
      dispatch(PracticeActions.getPracticeClients(token, practice));
      dispatch(PracticeActions.getPracticeStripeAccount(token, practice));
      dispatch(ScheduleActions.getPracticeAppointments(token, practice));
    }
    if (role === 'vet' || role === 'tech' || role === 'behaviorist') {
      dispatch(PracticeActions.getPracticeLocations(token, practice));
      dispatch(ConsultationsActions.getUserPreviewConsultations(token, 'ACTIVE'));
      dispatch(ConsultationsActions.getUserPreviewConsultations(token, 'RESOLVED'));
      dispatch(ScheduleActions.getUserAppointments(token, user_id));
    }
  }
}

const fetchDataForConsultationsScreen = (practice, role, token, user_id) => {
  return dispatch => {
    dispatch(ConsultationsActions.getAllConsultations('', null));
  }
}

const fetchDataForPracticeScreen = (practice, role, token, user_id) => {
  return dispatch => {
    if (role === 'practice_owner' || role === 'practice_manager' || role === 'admin') {
        dispatch(PracticeActions.getPracticeNotificationPreferences(token, practice));
        dispatch(PracticeActions.populateSelectedPracticeInfo());
        dispatch(PracticeActions.getPracticeLocations(token, practice));
        dispatch(PracticeActions.getPracticeBank(token, practice));
        dispatch(PracticeActions.getPracticeAlerts(token, practice));
        dispatch(PracticeActions.getPracticeStripeAccount(token, practice));
    }
  }
}

const fetchDataForStaffScreen = (practice, role, token, user_id) => {
  return dispatch => {
    if (role === 'practice_owner' || role === 'practice_manager' || role === 'admin') {
        dispatch(PracticeActions.getPracticeStaff(token, practice));
    }
  }
}

const fetchDataForClientsScreen = (practice, role, token, user_id) => {
  return dispatch => {
    if (role === 'practice_owner' || role === 'practice_manager' || role === 'admin') {
        dispatch(PracticeActions.getPracticeClients(token, practice));
    }
  }
}

const fetchDataForMyAccountScreen = (practice, role, token, user_id) => {
  return dispatch => {
    dispatch(UserActions.getUserRoles(token, user_id));
  }
}

const fetchDataForSettingsScreen = (practice, role, token, user_id) => {
  return dispatch => {
    dispatch(UserActions.getUserNotificationPreferences(token, user_id));
  }
}

const cleanPracticeSpecificData = () => {
  console.log('cleaning data')
  return dispatch => {
    dispatch({ type: actions.PRACTICE_LOCATIONS_UPDATE, payload: null });
    dispatch({ type: actions.PRACTICE_STAFF_UPDATE, payload: null });
    dispatch({ type: actions.PRACTICE_PATIENTS_UPDATE, payload: null });
    dispatch({ type: actions.PRACTICE_JOIN_REQUESTS_UPDATE, payload: null });
    dispatch({ type: actions.PRACTICE_USER_ROLE_UPDATE, payload: null });
    dispatch({ type: actions.PRACTICE_UPDATE_NOTIFICATION_PREFERENCES, payload: null });
    dispatch({ type: actions.SCHEDULE_UPDATE_PRACTICE_APT_IDS, payload: null });
    dispatch({ type: actions.SCHEDULE_UPDATE_PRACTICE_ALL_APT_IDS, payload: null });
    dispatch({ type: actions.SCHEDULE_UPDATE_USER_APT_IDS, payload: null });
    dispatch({ type: actions.SCHEDULE_UPDATE_USER_ALL_APT_IDS, payload: null });
    dispatch({ type: actions.PRACTICE_UPDATE_BANK, payload: null });
    dispatch({ type: actions.PRACTICE_UPDATE_STRIPE, payload: null });
    dispatch({ type: actions.CONSULTATIONS_CLEAR_DATA, payload: null });
    dispatch({ type: actions.PRACTICE_PROVIDER_LOCATION_DICT_UPDATE, payload: null });
    dispatch({ type: actions.INSTANT_CLEAR_DATA, payload: null });
  }
}

const setSelectedLocation = (location_id) => {
  return dispatch => {

    dispatch({ type: actions.CONTEXT_UPDATE_LOCATION, payload: location_id });

  }
}

export default {
  performNewPracticeTasks,
  switchLoggedInRole,
  switchLoggedInPracticeAndRole,
  updatedContextPracticeAndRole,
  fetchDataForScreenAndRole,
  setSelectedLocation,
}
